export default "__VITE_ASSET__DGLktr0f__"